export const defaultSettings = {
  analysisType: {
    name: 'Analysis Type',
    value: 1, // quicklook=1, advanced=2
    unit: null
  },
  fracType: {
    name: 'Frac Type',
    value: 1, // propped=1, unpropped=2
    unit: null
  },
  t_r: {
    name: 'Reservoir Temperature',
    value: 140,
    unit: '°F'
  },
  c_f: {
    name: 'Fracture Compressibility',
    value: 1e-4,
    unit: '1/psi'
  },
  c_f_unpropped: {
    name: 'Fracture Compressibility',
    value: 5e-4,
    unit: '1/psi'
  },
  p_p: {
    name: 'Primary Phase', 
    value: 1, // water=1, oil=2
    unit: null
  },
  g: {
    name: 'Gas Gravity (Air=1)',
    value: 0.747,
    unit: null
  },
  n2: {
    name: 'N2',
    value: 0,
    unit: '%'
  },
  co2: {
    name: 'CO2',
    value: 0,
    unit: '%'
  },
  h2s: {
    name: 'H2S',
    value: 0,
    unit: '%'
  },
  gor: {
    name: 'Gas Oil Ratio',
    value: 650,
    unit: 'scf/stb'
  },
  gamma: {
    name: 'API Oil Gravity',
    value: 40,
    unit: '°API'
  },
  solids_bbt: {
    name: 'Weight Percent Solids BBT',
    value: 0.05,
    unit: '%'
  },
  solids_abt: {
    name: 'Weight Percent Solids ABT',
    value: 0.1,
    unit: '%'
  },
  type: {
    name: 'Reservoir Type',
    value: 1, // tight oil=1, tight gas=2, shale gas=3
    unit: null
  },
  h: {
    name: 'Frac Height',
    value: 262.4,
    unit: 'ft'
  },
  phi_m: {
    name: 'Matrix Porosity',
    value: 0.04,
    unit: '%'
  },
  p_fi: {
    name: 'Initial Fracture Pressure',
    value: 5000,
    unit: 'psia'
  },
  s_w: {
    name: 'Initial Water Saturation',
    value: 1,
    unit: '%'
  },
  s_o: {
    name: 'Initial Oil Saturation',
    value: 0,
    unit: '%'
  },
  n_f: {
    name: 'Number of Fracs',
    value: 150,
    unit: null
  },
  phi_f: {
    name: 'Fracture Porosity',
    value: 0.31,
    unit: '%'
  },
  phi_f_unpropped: {
    name: 'Fracture Porosity',
    value: 0.62,
    unit: '%'
  },
  k_phi_exp: {
    name: 'Perm-Porosity Exponent',
    value: 0.000001,
    unit: null
  },
  flow: {
    name: 'Early Transient Flow Regime',
    value: 2, // radial=1, linear=2
    unit: null
  },
  shape: {
    name: 'Fracture Shape',
    value: 2, // circular=1, rectangular=2
    unit: null
  },
  w_f: {
    name: 'Individual Fracture Width',
    value: 0.25,
    unit: 'in'
  },
  w_f_unpropped: {
    name: 'Individual Fracture Width',
    value: 0.5,
    unit: 'in'
  },
  c_c: {
    name: 'Constant Compressibility',
    value: 1, // yes=1, no=2
    unit: null
  },
  c_phi: {
    name: 'Constant Porosity',
    value: 2, // yes=1, no=2
    unit: null
  },
  c_fluid: {
    name: 'Constant Fluid Properties',
    value: 1, // yes=1, no=2
    unit: null
  },
  r_w: {
    name: 'Wellbore Radius',
    value: 0.3,
    unit: 'ft'  
  },
  derivativeWindowRNP: {
    name: 'Derivative Window RNP',
    value: 1,
    unit: null  
  },
  derivativeWindowIRNP: {
    name: 'Derivative Window IRNP',
    value: 0.5,
    unit: null  
  },
  loadFluidPumped: {
    name: 'Load Fluid Pumped',
    value: 10000,
    unit: 'stb'  
  },
  fracsAttempted: {
    name: 'Fractures Attempted',
    value: 150,
    unit: null  
  },
  // diagnostic plots fit settings
  linearFlowFitIntercept: {
    name: 'Linear Flow Intercept',
    value: 202.6,
    unit: null  
  },
  linearFlowFitInterceptI: {
    name: 'Linear Flow Intercept Integral',
    value: 202.6,
    unit: null  
  },
  multiPhaseFitIntercept: {
    name: 'Multi-Phase Depletion Intercept',
    value: 0.1,
    unit: null  
  },
  fractureDepletionFitIntercept: {
    name: 'Fracture Depletion Intercept',
    value: 341.3,
    unit: null  
  },
  fractureDepletionFitInterceptI: {
    name: 'Fracture Depletion Intercept Integral',
    value: 341.3,
    unit: null  
  },
  linearFlowEndTmb: {
    name: 'Linear Flow End',
    value: 0.2,
    unit: null  
  },
  fractureConductivityLFTC: {
    name: 'Fracture Conductivity',
    value: 10.45,
    unit: 'md-ft'
  },
  useSkinLinearFlowTypeCurve: {
    name: 'Use Skin',
    value: 1, // 1 = yes, 2 = no
    unit: null
  },
  // History Match settings
  fractureConductivityPreBT: {
    name: 'Fracture Conductivity',
    value: 10.45,
    unit: 'md-ft'
  },
  lfSkinModel: {
    name: 'Linear Flow Skin Model',
    value: 1, // constant=1, variable=2
    unit: null
  },
  skinChangeParameter: {
    name: 'Skin Change Parameter (default=0.8)',
    value: 0.8,
    unit: null
  },
  skinPreBT: {
    name: 'Frac Skin Damage',
    value: 0.00000001,
    unit: null
  },
  drainageAreaPreBT: {
    name: 'Frac Area BBT',
    value: 5,
    unit: 'Acres'
  },
  skinPostBT: {
    name: 'Skin ABT',
    value: 0,
    unit: null
  },
  drainageAreaPostBT: {
    name: 'Frac Area ABT',
    value: 4,
    unit: 'Acres'
  },
  kroPostBT: {
    name: 'Corey Oil Rel. Perm. Coeff.',
    value: 1,
    unit: null
  },
  nPrimePostBT: {
    name: 'Corey Oil Rel. Perm. Exp.',
    value: 1,
    unit: null
  },
  mPrimePostBT: {
    name: 'Corey Water Rel. Perm. Exp.',
    value: 1,
    unit: null
  },
  formationCompressibility: {
    name: 'Formation Compressibility',
    value: 4e-6,
    unit: '1/psi'
  },
  mobileOilSaturation: {
    name: 'Mobile Oil Saturation',
    value: 0.90,
    unit: '%'
  },
  wtPercentSolidsMatrixInflow: {
    name: 'Weight Percent Solids',
    value: 0.2,
    unit: '%'
  },
  pbtMatrixInflow: {
    name: 'Estimated Breakthrough Pressure',
    value: 4000,
    unit: 'psia'
  },
  kMatrixInflow: {
    name: 'k',
    value: 0.0005,
    unit: 'md'
  },
  skinMatrixInflow: {
    name: 'skin',
    value: 0.0000001,
    unit: null
  },
  fractureSpacingMatrixInflow: {
    name: 'Frac Spacing',
    value: 50,
    unit: 'ft'
  },
  kroMatrixInflow: {
    name: 'Corey Oil Rel. Perm. Coeff.',
    value: 1,
    unit: null
  },
  nPrimeMatrixInflow: {
    name: 'Corey Oil Rel. Perm. Exp.',
    value: 3,
    unit: null
  },
  mPrimeMatrixInflow: {
    name: 'Corey Water Rel. Perm. Exp.',
    value: 3,
    unit: null
  },
  // WELLBORE MODEL SETTINGS
  id: {
    name: 'Wellbore Inner Diameter',
    value: 5,
    unit: 'in'
  },
  roughness: {
    name: 'Pipe Wall Roughness',
    value: 0.001,
    unit: 'in'
  },
  pressureMethod: {
    name: 'Pressure Method',
    value: 2, // hagedorn and brown = 1, beggs and brill = 2
    unit: null
  },
  temperatureMethod: {
    name: 'Temperature Method',
    value: 1, // linear=1, shiu=2
    unit: null
  },
  frictionFactorMethod: {
    name: 'Friction Factor Method',
    value: 1, // serghide=1, chen=2
    unit: null
  },
  geothermalGradient: {
    name: 'Geothermal Gradient',
    value: 0.8,
    unit: '°F / 100 ft'
  },
  wht: {
    name: 'Wellhead Temperature',
    value: 130,
    unit: '°F'
  },
  sgWater: {
    name: 'Water SG',
    value: 1.05,
    unit: null
  },
  errorTolerance: {
    name: 'Error Tolerance',
    value: 0.1,
    unit: null
  },
  midPointPerfs: {
    name: 'Mid Point of Perforations MD',
    value: 0,
    unit: 'ft'
  },
  rB: {
    name: 'Solution Gas-Oil Ratio at Psat',
    value: 1250,
    unit: 'scf/bbl'
  },
  // FIT LINES
  sqrtTimeFitSlope: {
    name: 'Square Root Time Slope',
    value: 0.525,
    unit: null
  },
  sqrtTimeFitIntercept: {
    name: 'Square Root Time Intercept',
    value: 0,
    unit: null
  },
  fmbFitSlope: {
    name: 'FMB Slope',
    value: -0.000166,
    unit: null
  },
  fmbFitIntercept: {
    name: 'FMB Intercept',
    value: 6.1,
    unit: null
  },
  linearDaysStart: {
    name: 'Start Real Time',
    value: 0.05,
    unit: 'days'
  },
  linearDaysEnd: {
    name: 'End Real Time',
    value: 0.1,
    unit: 'days'
  },
  units: {
    name: 'Units',
    value: 'field',
    unit: null
  },
  // gas model
  mobileGasSaturation: {
    name: 'Mobile Gas Saturation',
    value: 0.55,
    unit: '%'
  },
  cgr: {
    name: 'CGR',
    value: 10,
    unit: 'stb/mmscf'
  },
  tSep: {
    name: 'Tsep',
    value: 100,
    unit: '°F'
  },
  pSep: {
    name: 'Psep',
    value: 100,
    unit: 'psi'
  },
  condensateApi: {
    name: 'API Condensate',
    value: 50,
    unit: null
  },
  krgPostBT: {
    name: 'Corey Gas Rel. Perm. Coeff.',
    value: 0.1,
    unit: null
  },
  nPrimePostBTGas: {
    name: 'Corey Gas Rel. Perm. Exp.',
    value: 1,
    unit: null
  },
  krgMatrixInflow: {
    name: 'Corey Gas Rel. Perm. Coeff.',
    value: 1,
    unit: null
  },
  nPrimeMatrixInflowGas: {
    name: 'Corey Gas Rel. Perm. Exp.',
    value: 3,
    unit: null
  },
}